<template lang="pug">
div
	h3 Report options

	p: b Type of report of you want to order.

	.checkout-item
		.description
			b-form-checkbox(v-model='products[sku.report].checked', id='report', @input='checkRepRules(sku.report)')
			label(for='report') Title 24 Energy Compliance Report for submission to the Building Department
			help-button(id="1026")
		.price $ {{ products[sku.report].price }} Base price

	.checkout-item
		.description
			b-form-checkbox(v-model='products[sku.prelimRun].checked', id='prelimRun', @input='checkRepRules(sku.prelimRun)')
			label(for='prelimRun') Preliminary Run results only
			help-button(id="1028")
		.price $ {{ products[sku.prelimRun].price }} Base price

	.checkout-item
		.description
			b-form-checkbox(v-model='products[sku.heatCoolLoad].checked', id='heatCoolLoad', @input='checkRepRules(sku.heatCoolLoad)')
			label(for='heatCoolLoad') Heating and Cooling Load Calculations only
			help-button(id="1029")
		.price $ {{ products[sku.heatCoolLoad].price }} Base price

	p: b Premium options

	p Our Reports are delivered within 72 hours, our Standard Delivery Term.
		span(v-if='isRushAvail')  If you need your report delivered sooner, please indicate this below.

	.checkout-item(v-if='isRushAvail')
		.description
			b-form-checkbox(v-model='products[sku.rush].checked', id='rush', @input='checkRepRules(sku.rush)')
			label(for='rush') Rush Service - Report delivered within 24 hours
		.price Add $ {{ products[sku.rush].price }}

	.checkout-item
		.description
			b-form-checkbox(v-model='products[sku.certify].checked', id='certify', @input='checkRepRules(sku.certify)', :disabled='products[sku.certify].disabled')
			label(for='certify') I want this report signed & stamped by a Certified Energy Analyst (Not available for Preliminary Run results)
		.price Add $ {{ products[sku.certify].price }}

	//- .text-right
	//- 	input(type="submit", value="Next", @click="next")
	.div-container-right
		span
		a(@click="next")
			easyBtn(btnText="Next")

</template>

<script>
import store from 'CommonApp/store'
import moment from 'moment'
import { mapActions } from 'vuex'
import easyBtn from 'Common/components/easy-btn.vue'

export default {
	name: 'checkout-report-options',
	props: ['products', 'project', 'sku'],
	components: { easyBtn },
	data () {
		return {
			isRushAvail: true
		}
	},
	created () {
		// if nothing is selected, default to a full report
		if (
			this.products[this.sku.prelimRun].checked === false &&
			this.products[this.sku.report].checked === false &&
			this.products[this.sku.heatCoolLoad].checked === false
		) {
			this.products[this.sku.report].checked = true
			this.products[this.sku.certify].disabled = false
		}
	},
	// pp-TODO added this here based on other similar code. Is this where this should happen?
	beforeMount () {
		const suspendRushServiceSchedule = this.$e24Common.storageService.findItem('config', true).suspendRushServiceSchedule
		this.isRushAvail = !moment().isBetween(suspendRushServiceSchedule.from, suspendRushServiceSchedule.to)
	},
	methods: {
		...mapActions(['addToCart']),

		// Check report selection rules
		checkRepRules (sku) {
			// if nothing is selected, default to a full report
			if (
				this.products[this.sku.prelimRun].checked === false &&
				this.products[this.sku.report].checked === false &&
				this.products[this.sku.heatCoolLoad].checked === false
			) {
				this.products[this.sku.report].checked = true
				this.products[this.sku.certify].disabled = false
			}

			// if prelimRun is selected, the 'signed & stamped' option is not available (certify)
			this.products[this.sku.certify].disabled = this.products[this.sku.prelimRun].checked
			if (this.products[this.sku.certify].disabled) {
				this.products[this.sku.certify].checked = false
			}

			if (this.products[sku].checked) {
				if (sku === this.sku.report) {
					this.products[this.sku.prelimRun].checked = false
					this.products[this.sku.heatCoolLoad].checked = false
					this.products[this.sku.certify].disabled = false // Enable certify
				} else if (
					sku === this.sku.prelimRun ||
					sku === this.sku.heatCoolLoad
				) {
					this.products[this.sku.report].checked = false
				}
			}
		},
		next () {
			store.dispatch({
				type: 'changeCheckoutActiveTab',
				value: 'tab-delivery-options'
			})
		}
	}
}
</script>

<style lang="less">
.div-container-right {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.description {
  display: flex;
  flex-direction: row;
}
.report-row {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/app/checkout/tabs-components/report-options.vue